import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-mt-2 tw-space-y-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-mb-1 tw-text-xs tw-font-medium tw-text-slate-600 dark:tw-text-slate-300" }, "Password requirements", -1)
const _hoisted_3 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requirements, (requirement) => {
      return (_openBlock(), _createElementBlock("div", {
        key: requirement.key,
        class: "tw-flex tw-items-center tw-gap-2 tw-text-xs",
        "data-testid": `password-requirement-${requirement.key}`
      }, [
        _createElementVNode("span", {
          class: _normalizeClass([
          'tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full tw-text-[10px] tw-font-bold',
          requirement.isValid
            ? 'tw-bg-green-100 tw-text-green-600 dark:tw-bg-green-900 dark:tw-text-green-400'
            : 'tw-bg-red-100 tw-text-red-600 dark:tw-bg-red-900 dark:tw-text-red-400'
        ])
        }, _toDisplayString(requirement.isValid ? '✓' : '✗'), 3),
        _createElementVNode("span", {
          class: _normalizeClass([
          requirement.isValid ? 'tw-text-green-600 dark:tw-text-green-400' : 'tw-text-red-600 dark:tw-text-red-400'
        ])
        }, _toDisplayString(requirement.label), 3)
      ], 8, _hoisted_3))
    }), 128))
  ]))
}